module.exports = __webpack_public_path__ + "static/img/victim-teens-2.8b80ebb6.png";